const BASE_URL = 'https://docno-admin-ap.hakaru-cloud.jp/v1/api-master'; // 検証環境API

export default BASE_URL;
